var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"upload_box"},[_c('input',{attrs:{"id":"uploadForm","type":"file","accept":"","multiple":""},on:{"change":function($event){_vm.changePic($event)}}})])}
var staticRenderFns = []

export { render, staticRenderFns }